import Component from '../core/Component'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

const template = `
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
                <div class="pswp__counter"></div>

                <button class="pswp__button pswp__button--share" title="Share"></button>
                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                      <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                      </div>
                    </div>
                </div>

                <button class="pswp__button pswp__button--close" title="Close (Esc)">
                    <span class="Icon Icon--caretLeft"></span>
                    <span>{replace}</span>
                </button>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" type="button">
                <div class="ButtonOctagon ButtonOctagon--solid">
                    <svg class="ButtonOctagon-shape" width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M100,1.0823922 L30.0546887,30.0546887 L1.0823922,100 L30.0546887,169.945311 L100,198.917608 L169.945311,169.945311
                        L198.917608,100 L169.945311,30.0546887 L100,1.0823922 Z" stroke="#A1102A" fill="none" stroke-width="2"></path>
                    </svg>
                    <div class="ButtonOctagon-text"><span class="Icon Icon--arrowLeft"></span></div>
                </div>
            </button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)" type="button">
                <div class="ButtonOctagon ButtonOctagon--solid">
                    <svg class="ButtonOctagon-shape" width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M100,1.0823922 L30.0546887,30.0546887 L1.0823922,100 L30.0546887,169.945311 L100,198.917608 L169.945311,169.945311
                        L198.917608,100 L169.945311,30.0546887 L100,1.0823922 Z" stroke="#A1102A" fill="none" stroke-width="2"></path>
                    </svg>
                    <div class="ButtonOctagon-text"><span class="Icon Icon--arrowRight"></span></div>
                </div>
            </button>
            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>
        </div>
    </div>
</div>`

export default class Lightbox extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        if (this.element.dataset.photos) {
            this.photos = JSON.parse(this.element.dataset.photos).photos
        } else {
            this.photos = this.ref.items.map($element => JSON.parse($element.dataset.photos).photos)
            this.photos = [].concat.apply([], this.photos)
        }
    }

    prepare() {
        this.buffer  = document.createElement('div')
        this.buffer.innerHTML = template.replace('{replace}', this.element.dataset.backButton)

        document.body.appendChild(this.buffer)

        if (this.ref.items.length > 0) {
            this.ref.items.map(($element, index) => {
                $element.addEventListener('click', (event) => {
                    this.open()
                    this.gallery.goTo(parseInt(index, 10))
                })
            })
        } else {
            this.element.addEventListener('click', this.handleClick)
        }
    }

    pswpInit() {
        this.galleryRoot = this.buffer.querySelector('.pswp')

        const options = {
            index: 0,
            shareEl: false,
            fullscreenEl: false,
            zoomEl: false,
            counterEl: false,
            showHideOpacity: false,
            bgOpacity: .4,
            history: false,
            fullscreenEl: false,
            zoomEl: false,
            modal: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0
        }

        this.gallery = new PhotoSwipe(this.galleryRoot, PhotoSwipeUI_Default, this.photos, options)
        this.gallery.init();
    }

    handleClick = event => {
        event.preventDefault()

        this.open()
    }

    open() {
        this.pswpInit()
    }
}